import {
  ADD_EDIT_GOALS_ASSESSMENT_FAILURE,
  ADD_EDIT_GOALS_ASSESSMENT_REQUEST,
  ADD_EDIT_GOALS_ASSESSMENT_SUCCESS,
  ADD_PERSONAL_SMART_GOALS_FAILURE,
  ADD_PERSONAL_SMART_GOALS_REQUEST,
  ADD_PERSONAL_SMART_GOALS_SUCCESS,
  ADD_WHERE_TO_FROM_HERE_FAILURE,
  ADD_WHERE_TO_FROM_HERE_REQUEST,
  ADD_WHERE_TO_FROM_HERE_SUCCESS,
  DELETE_PERSONAL_SMART_GOALS_FAILURE,
  DELETE_PERSONAL_SMART_GOALS_REQUEST,
  DELETE_PERSONAL_SMART_GOALS_SUCCESS,
  GET_CURRENT_SLP_GOALS_PDF_FAILURE,
  GET_CURRENT_SLP_GOALS_PDF_REQUEST,
  GET_CURRENT_SLP_GOALS_PDF_SUCCESS,
  GET_PERSONAL_SMART_GOALS_BY_SLP_ID_FAILURE,
  GET_PERSONAL_SMART_GOALS_BY_SLP_ID_REQUEST,
  GET_PERSONAL_SMART_GOALS_BY_SLP_ID_SUCCESS,
  GET_PERSONAL_SMART_GOALS_FAILURE,
  GET_PERSONAL_SMART_GOALS_REQUEST,
  GET_PERSONAL_SMART_GOALS_SUCCESS,
  HOPES_GOALS_AMBITIONS_FAILURE,
  HOPES_GOALS_AMBITIONS_REQUEST,
  HOPES_GOALS_AMBITIONS_SUCCESS,
  UPDATE_HOPES_GOALS_AMBITIONS_FAILURE,
  UPDATE_HOPES_GOALS_AMBITIONS_REQUEST,
  UPDATE_HOPES_GOALS_AMBITIONS_SUCCESS,
} from "./actionTypes";

import {
  AddEditGoalsAssessmentFailure,
  AddEditGoalsAssessmentFailurePayload,
  AddEditGoalsAssessmentPayload,
  AddEditGoalsAssessmentRequest,
  AddEditGoalsAssessmentSuccess,
  AddEditGoalsAssessmentSuccessPayload,
  AddPersonalAndSmartGoalsFailure,
  AddPersonalAndSmartGoalsFailurePayload,
  AddPersonalAndSmartGoalsPayload,
  AddPersonalAndSmartGoalsRequest,
  AddPersonalAndSmartGoalsSuccess,
  AddPersonalAndSmartGoalsSuccessPayload,
  DeletePersonalAndSmartGoalsFailure,
  DeletePersonalAndSmartGoalsFailurePayload,
  DeletePersonalAndSmartGoalsPayload,
  DeletePersonalAndSmartGoalsRequest,
  DeletePersonalAndSmartGoalsSuccess,
  DeletePersonalAndSmartGoalsSuccessPayload,
  GetCurrentSLPGoalsPDFFailure,
  GetCurrentSLPGoalsPDFFailurePayload,
  GetCurrentSLPGoalsPDFPayload,
  GetCurrentSLPGoalsPDFRequest,
  GetCurrentSLPGoalsPDFSuccess,
  GetCurrentSLPGoalsPDFSuccessPayload,
  HopesGoalsAndAmbitionsFailure,
  HopesGoalsAndAmbitionsFailurePayload,
  HopesGoalsAndAmbitionsPayload,
  HopesGoalsAndAmbitionsRequest,
  HopesGoalsAndAmbitionsSuccess,
  HopesGoalsAndAmbitionsSuccessPayload,
  PersonalAndSmartGoalsBySlpIdFailure,
  PersonalAndSmartGoalsBySlpIdFailurePayload,
  PersonalAndSmartGoalsBySlpIdPayload,
  PersonalAndSmartGoalsBySlpIdRequest,
  PersonalAndSmartGoalsBySlpIdSuccess,
  PersonalAndSmartGoalsBySlpIdSuccessPayload,
  PersonalAndSmartGoalsFailure,
  PersonalAndSmartGoalsFailurePayload,
  PersonalAndSmartGoalsPayload,
  PersonalAndSmartGoalsRequest,
  PersonalAndSmartGoalsSuccess,
  PersonalAndSmartGoalsSuccessPayload,
  UpdateHopesGoalsAndAmbitionsFailure,
  UpdateHopesGoalsAndAmbitionsFailurePayload,
  UpdateHopesGoalsAndAmbitionsPayload,
  UpdateHopesGoalsAndAmbitionsRequest,
  UpdateHopesGoalsAndAmbitionsSuccess,
  UpdateHopesGoalsAndAmbitionsSuccessPayload,
  WhereToFromHereFailure,
  WhereToFromHereFailurePayload,
  WhereToFromHerePayload,
  WhereToFromHereRequest,
  WhereToFromHereSuccess,
  WhereToFromHereSuccessPayload,
} from "./types";

export const hopesGoalsAndAmbitionsRequest = (
  payload: HopesGoalsAndAmbitionsPayload
): HopesGoalsAndAmbitionsRequest => ({
  type: HOPES_GOALS_AMBITIONS_REQUEST,
  payload,
});

export const hopesGoalsAndAmbitionsSuccess = (
  payload: HopesGoalsAndAmbitionsSuccessPayload
): HopesGoalsAndAmbitionsSuccess => ({
  type: HOPES_GOALS_AMBITIONS_SUCCESS,
  payload,
});

export const hopesGoalsAndAmbitionsFailure = (
  payload: HopesGoalsAndAmbitionsFailurePayload
): HopesGoalsAndAmbitionsFailure => ({
  type: HOPES_GOALS_AMBITIONS_FAILURE,
  payload,
});

export const updateHopesGoalsAndAmbitionsRequest = (
  payload: UpdateHopesGoalsAndAmbitionsPayload
): UpdateHopesGoalsAndAmbitionsRequest => ({
  type: UPDATE_HOPES_GOALS_AMBITIONS_REQUEST,
  payload,
});

export const updateHopesGoalsAndAmbitionsSuccess = (
  payload: UpdateHopesGoalsAndAmbitionsSuccessPayload
): UpdateHopesGoalsAndAmbitionsSuccess => ({
  type: UPDATE_HOPES_GOALS_AMBITIONS_SUCCESS,
  payload,
});

export const updateHopesGoalsAndAmbitionsFailure = (
  payload: UpdateHopesGoalsAndAmbitionsFailurePayload
): UpdateHopesGoalsAndAmbitionsFailure => ({
  type: UPDATE_HOPES_GOALS_AMBITIONS_FAILURE,
  payload,
});

export const addPersonalAndSmartGoalsRequest = (
  payload: AddPersonalAndSmartGoalsPayload
): AddPersonalAndSmartGoalsRequest => ({
  type: ADD_PERSONAL_SMART_GOALS_REQUEST,
  payload,
});

export const addPersonalAndSmartGoalsSuccess = (
  payload: AddPersonalAndSmartGoalsSuccessPayload
): AddPersonalAndSmartGoalsSuccess => ({
  type: ADD_PERSONAL_SMART_GOALS_SUCCESS,
  payload,
});

export const addPersonalAndSmartGoalsFailure = (
  payload: AddPersonalAndSmartGoalsFailurePayload
): AddPersonalAndSmartGoalsFailure => ({
  type: ADD_PERSONAL_SMART_GOALS_FAILURE,
  payload,
});

export const addEditGoalsAssessmentRequest = (
  payload: AddEditGoalsAssessmentPayload
): AddEditGoalsAssessmentRequest => ({
  type: ADD_EDIT_GOALS_ASSESSMENT_REQUEST,
  payload,
});

export const addEditGoalsAssessmentSuccess = (
  payload: AddEditGoalsAssessmentSuccessPayload
): AddEditGoalsAssessmentSuccess => ({
  type: ADD_EDIT_GOALS_ASSESSMENT_SUCCESS,
  payload,
});

export const addEditGoalsAssessmentFailure = (
  payload: AddEditGoalsAssessmentFailurePayload
): AddEditGoalsAssessmentFailure => ({
  type: ADD_EDIT_GOALS_ASSESSMENT_FAILURE,
  payload,
});

export const deletePersonalAndSmartGoalsRequest = (
  payload: DeletePersonalAndSmartGoalsPayload
): DeletePersonalAndSmartGoalsRequest => ({
  type: DELETE_PERSONAL_SMART_GOALS_REQUEST,
  payload,
});

export const deletePersonalAndSmartGoalsSuccess = (
  payload: DeletePersonalAndSmartGoalsSuccessPayload
): DeletePersonalAndSmartGoalsSuccess => ({
  type: DELETE_PERSONAL_SMART_GOALS_SUCCESS,
  payload,
});

export const deletePersonalAndSmartGoalsFailure = (
  payload: DeletePersonalAndSmartGoalsFailurePayload
): DeletePersonalAndSmartGoalsFailure => ({
  type: DELETE_PERSONAL_SMART_GOALS_FAILURE,
  payload,
});

export const personalAndSmartGoalsRequest = (
  payload: PersonalAndSmartGoalsPayload
): PersonalAndSmartGoalsRequest => ({
  type: GET_PERSONAL_SMART_GOALS_REQUEST,
  payload,
});

export const personalAndSmartGoalsSuccess = (
  payload: PersonalAndSmartGoalsSuccessPayload
): PersonalAndSmartGoalsSuccess => ({
  type: GET_PERSONAL_SMART_GOALS_SUCCESS,
  payload,
});

export const personalAndSmartGoalsFailure = (
  payload: PersonalAndSmartGoalsFailurePayload
): PersonalAndSmartGoalsFailure => ({
  type: GET_PERSONAL_SMART_GOALS_FAILURE,
  payload,
});

export const personalAndSmartGoalsBySlpIdRequest = (
  payload: PersonalAndSmartGoalsBySlpIdPayload
): PersonalAndSmartGoalsBySlpIdRequest => ({
  type: GET_PERSONAL_SMART_GOALS_BY_SLP_ID_REQUEST,
  payload,
});

export const personalAndSmartGoalsBySlpIdSuccess = (
  payload: PersonalAndSmartGoalsBySlpIdSuccessPayload
): PersonalAndSmartGoalsBySlpIdSuccess => ({
  type: GET_PERSONAL_SMART_GOALS_BY_SLP_ID_SUCCESS,
  payload,
});

export const personalAndSmartGoalsBySlpIdFailure = (
  payload: PersonalAndSmartGoalsBySlpIdFailurePayload
): PersonalAndSmartGoalsBySlpIdFailure => ({
  type: GET_PERSONAL_SMART_GOALS_BY_SLP_ID_FAILURE,
  payload,
});

export const getCurrentSLPGoalsPDFRequest = (
  payload: GetCurrentSLPGoalsPDFPayload
): GetCurrentSLPGoalsPDFRequest => ({
  type: GET_CURRENT_SLP_GOALS_PDF_REQUEST,
  payload,
});

export const getCurrentSLPGoalsPDFSuccess = (
  payload: GetCurrentSLPGoalsPDFSuccessPayload
): GetCurrentSLPGoalsPDFSuccess => ({
  type: GET_CURRENT_SLP_GOALS_PDF_SUCCESS,
  payload,
});
export const getCurrentSLPGoalsPDFFailure = (
  payload: GetCurrentSLPGoalsPDFFailurePayload
): GetCurrentSLPGoalsPDFFailure => ({
  type: GET_CURRENT_SLP_GOALS_PDF_FAILURE,
  payload,
});

export const whereToFromHereRequest = (
  payload: WhereToFromHerePayload
): WhereToFromHereRequest => ({
  type: ADD_WHERE_TO_FROM_HERE_REQUEST,
  payload,
});

export const whereToFromHereSuccess = (
  payload: WhereToFromHereSuccessPayload
): WhereToFromHereSuccess => ({
  type: ADD_WHERE_TO_FROM_HERE_SUCCESS,
  payload,
});

export const whereToFromHereFailure = (
  payload: WhereToFromHereFailurePayload
): WhereToFromHereFailure => ({
  type: ADD_WHERE_TO_FROM_HERE_FAILURE,
  payload,
});
